// Runtime importmap (FA209) — ONLY packages this project dynamic-imports at
// runtime. @elevenlabs/client is the live voice agent of a talk call
// (components/VoiceOverlay.js `scope.agentClient` — `await
// import('@elevenlabs/client')`, FA206; Nika 2026-10-26 "11labs talks, Simone
// acts"); pinned to the exact version the engine was written against, the
// same pin as package.json.
//
// prismjs / fuse.js / lottie-web were three more bare dynamic imports
// (CodePreview.js `await import('prismjs')`, CanvasSearchDropdown.js
// `await import('fuse.js')`, Lottie.js `await import('lottie-web')`) that
// had never been declared here — the browser's importmap has no entry for
// a bare specifier that isn't listed, so every one of those imports threw
// "Failed to resolve module specifier" 100% of the time (not an
// intermittent CDN hiccup), leaving CodePreview/Command/Lottie/CanvasMessage/
// CanvasHelpCard/SearchBtn permanently empty everywhere this library is
// consumed, workspace-ui catalog included. Versions pinned to match the
// root `bun.lock` (`prismjs@1.30.0`, `fuse.js@7.4.2`, `lottie-web@5.13.0`)
// so dev and the runtime importmap resolve the same code.
//
// js-beautify is the fifth (functions/prettifyCode.js `await
// import('js-beautify')`), at the version brand declares (brand
// dependencies.js: js-beautify 2.0.3, lottie-web 5.13.0, prismjs 1.30.0 —
// the three match). acorn is the sixth (methods/code.js parseStringCode
// `await import('acorn')`), at the version the root bun.lock resolves
// (acorn@8.19.0). __tests__/dynamicImportsDeclared.test.js pins every bare
// runtime import to an entry here, with no list of owed gaps.
export default {
  '@elevenlabs/client': '1.30.0',
  prismjs: '1.30.0',
  'fuse.js': '7.4.2',
  'lottie-web': '5.13.0',
  'js-beautify': '2.0.3',
  acorn: '8.19.0'
}
